module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!./Website.js"));
	}, "Website");
}